
import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../../redux/projects/actions.projects';
import * as analyticsActions from '../../../../redux/analytics/actions.analytics';
import PopupBody from '../../../components/Popup/PopupBody';
import PopupHeader from '../../../components/Popup/PopupHeader';
import PopupWrapper from '../../../components/Popup/PopupWrapper';
import withClickOutsideOnOverlay from '../../../../hoc/withClickOutsideOnOverlay';
import BillingForms from '../BillingForms/BillingForms';
import store from '../../../../store';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import ToasterService from '../../../../services/ToasterService';
import device from '../../../../services/mini/device';
import cancelEvent from '../../../../services/mini/cancelEvent';
import PaymentCardInfoItem from '../PaymentCardInfoItem/PaymentCardInfoItem';
import { pages, actions as planActions } from '../../../../const/plansAnalytics';
const $ = require('jquery');
class ChangePaymentCardPopup extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            showCardPaymentForm: true,
            markedToChangeCardId: null,
            markedToDeleteCardId: null,
            deletingCardId: null
        };

        this.popupBodyEl = React.createRef();
        this.cardList = React.createRef();
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    cancel = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    addNewCard = () => {
        const { trackPlanAction } = this.props;
        trackPlanAction({ page: pages.billing, action: planActions.openFormForAddingNewCard });
        this.setState({ showCardPaymentForm: true }, () => {
            $(this.popupBodyEl.current).closest('.change-payment-card-popup__body')
                .animate({
                    scrollTop: this.cardList.current.getBoundingClientRect().height + 10
                }, 600);
        });
    }

    selectCard = (card) => {
        const { changePaymentMethod, currentPlan, trackPlanAction } = this.props;

        this.setState({ markedToChangeCardId: card.paymentMethodId });

        trackPlanAction({
            page: pages.billing,
            action: planActions.changeCardForPlan,
            params: JSON.stringify({ brand: card.brand, last4: card.last4 })
        });

        changePaymentMethod({
            planId: currentPlan.id,
            paymentType: 'stripe',
            paymentMethod: card.paymentMethodId
        }).then(() => {
            if (this._isMounted) {
                this.setState({ markedToChangeCardId: null });
            }
        });
    }

    deleteCard = (card, e) => {
        if (card.isActive) {
            ToasterService.showWarning({ title: 'You cannot delete your current active card. Please select or add another card to delete this one' });
        } else {
            this.setState({ markedToDeleteCardId: card.paymentMethodId });
        }
        cancelEvent(e);
    }

    cancelDeletingCard = (e) => {
        this.setState({ markedToDeleteCardId: null });
        cancelEvent(e);
    }

    confirmDeletingCard = (card, e) => {
        const { deletePaymentMethod, trackPlanAction } = this.props;
        cancelEvent(e);
        trackPlanAction({
            page: pages.billing,
            action: planActions.removeCard,
            params: JSON.stringify({ brand: card.brand, last4: card.last4 })
        });

        this.setState({ deletingCardId: card.paymentMethodId }, async () => {
            try {
                await deletePaymentMethod({
                    paymentMethodId: card.paymentMethodId
                });
            } catch (e) {

            }
            this.setState({
                markedToDeleteCardId: null,
                deletingCardId: null,
            });
        });
    }

    finishAddingNewCard = () => {
        ToasterService.showInfo({ title: 'A new card for future payments is successfully added' });
        this.cancel();
    }

    render() {
        const { cards } = this.props;
        const {
            showCardPaymentForm,
            markedToChangeCardId,
            markedToDeleteCardId,
            deletingCardId } = this.state;
        const amount = 1;
        const infoMsg = `We need to verify your credit card. This amount will be refunded back shortly, and you will be automatically charged $${amount} at the beginning of a new period.`;
        return <PopupWrapper className={`change-payment-card-popup ${!device.isDesktop() && 'mobile'}`} >
            <PopupHeader
                title="Please provide a credit card for subscription payments"
                onCancel={this.cancel}
            />

            <PopupBody className="change-payment-card-popup__body">
                <div className="change-payment-card-popup__cards-list" ref={this.popupBodyEl}>
                    {/* <div ref={this.cardList} >
                        {cards.map((card, i) => {
                            const willBeChanged = markedToChangeCardId === card.paymentMethodId;
                            const willBeDeleted = markedToDeleteCardId === card.paymentMethodId;
                            const isDeletingNow = deletingCardId === card.paymentMethodId;
                            return <div
                                key={`${i}-${willBeChanged}-${willBeDeleted}`}
                                onClick={() => { this.selectCard(card); }}
                                className={`change-payment-card-popup__card-item-wrapper ${(card.isActive && !markedToChangeCardId) && 'active'} ${willBeChanged && 'in-process btn-loader-light'}`}>
                                <PaymentCardInfoItem  {...card} showCardName={true} />
                                {!markedToChangeCardId && <div
                                    className="change-payment-card-popup__delete-card-item-btn"
                                    onClick={(e) => { this.deleteCard(card, e); }}  >
                                    <i className="icon icon-alan-remove-sign" />
                                </div>}

                                {willBeDeleted && <div className={`change-payment-card-popup__card-item-action-btns ${isDeletingNow && 'disabled-without-opacity'}`}>
                                    <div className="action-btn light-blue-with-border" onClick={this.cancelDeletingCard}>Cancel</div>
                                    <div className={`action-btn light-red ${isDeletingNow && 'btn-loader-red'}`} onClick={(e) => this.confirmDeletingCard(card, e)}>Delete</div>
                                </div>}
                            </div>;
                        })}
                    </div> */}

                    <div className="change-payment-card-popup__new-card-form">
                        {/* {!showCardPaymentForm ?
                            <div
                                onClick={this.addNewCard}
                                className="action-btn light-blue-with-border add-new-card-btn">Add new card</div> :
                            <React.Fragment> */}
                        <BillingForms
                            readOnlyAmount={true}
                            amount={amount}
                            infoMsg={infoMsg}
                            store={store}
                            hidePromoCodeBtn={true}
                            hidePaypalBtn={true}
                            hideCardsBtn={true}
                            expandStripeSection={true}
                            stripeFormTitle="Credit Card Verification"
                            stripeBtnTitle="Verify Card"
                            onBillingFinishedCb={this.finishAddingNewCard}
                            refund={true}
                        />
                        {/* </React.Fragment>
                        } */}
                    </div>
                </div>
            </PopupBody>
        </PopupWrapper>;
    }
}

function mapStateToProps({ user }) {
    return {
        currentPlan: user.currentPlan,
        cards: user.cards,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        changePaymentMethod: (param) => asyncDispatch(actions.changePaymentMethod, dispatch, param),
        deletePaymentMethod: (param) => asyncDispatch(actions.deletePaymentMethod, dispatch, param),
        trackPlanAction: (param) => asyncDispatch(analyticsActions.trackPlanAction, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withClickOutsideOnOverlay(ChangePaymentCardPopup));